import { createRoot } from 'react-dom/client';

const roots = new WeakMap();

export const renderRoot = (element, container) => {
  let root = roots.get(container);
  if (!root) {
    root = createRoot(container);
    roots.set(container, root);
  }
  root.render(element);
};

export const unmountRoot = (container) => {
  const root = roots.get(container);
  if (!root) return;

  root.unmount();
  roots.delete(container);
};
